import { useState, useEffect, useMemo } from "react";
import { SEND_EVENTS_TO_PENDO, PENDO_API_KEY } from "env-vars";
import { pendoSnippet } from "./pendo-snippet";
import { useLocationContext } from "context/location";

interface PendoAccount {
  id?: string | null;
  name?: string | null;
}

interface PendoProps {
  account?: PendoAccount;
  isDataLoading?: boolean;
}

export function Pendo({ account: accountProp, isDataLoading }: PendoProps = {}) {
  const [pendoInitialised, setPendoInitialised] = useState<boolean | null>(
    null
  );
  const locationData = useLocationContext();

  const isLoading = isDataLoading ?? locationData?.isLoading ?? false;

  const account = useMemo<PendoAccount>(() => {
    if (accountProp) return accountProp;
    if (!locationData?.location) return {};
    return {
      id: locationData.location.organization_id,
      name: locationData.location.organization_name,
    };
  }, [accountProp, locationData?.location]);

  useEffect(() => {
    if (isLoading) {
      setPendoInitialised(false);
      return;
    }

    if (pendoInitialised) return;

    if (!PENDO_API_KEY || !SEND_EVENTS_TO_PENDO) {
      setPendoInitialised(false);

      return;
    }

    pendoSnippet({ apiKey: PENDO_API_KEY, account });

    setPendoInitialised(true);
  }, [pendoInitialised, isLoading, account]);

  return <div style={{ display: "none" }} data-pendo-init={pendoInitialised} />;
}
